import { render, staticRenderFns } from "./ColorPickerStep.vue?vue&type=template&id=0c0b00df&scoped=true"
import script from "./ColorPickerStep.vue?vue&type=script&lang=js"
export * from "./ColorPickerStep.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerStep.vue?vue&type=style&index=0&id=0c0b00df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b00df",
  null
  
)

export default component.exports